<template>
  <div>
    <div class="btn-group mr-2 d-none d-lg-block">
      <button
        tag="button"
        type="button"
        class="btn btn-primary dropdown-toggle-right"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div style="display:flex; align-items:center">
          <i class="material-icons" style="margin-right:7px">tablet</i>Device
        </div>
        <span class="sr-only">Toggle Dropdown</span>
      </button>

      <div class="dropdown-menu dropdown-menu-right">
        <ul v-if="deviceInfo.hasInfo" class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="font-weight-bold">ID:</span>
            <span class="float-right text-capitalize">{{deviceInfo.device_id}}</span>
          </li>
          <li class="list-group-item">
            <span class="font-weight-bold">Product:</span>
            <span class="float-right">corpuls simulation</span>
          </li>
        </ul>
        <ul v-if="!deviceInfo.hasInfo" class="list-group list-group-flush">
          <li class="list-group-item">No device info</li>
        </ul>
      </div>
    </div>
    <!-- desktop -->
    <div class="btn-group mr-2 d-block d-lg-none">
      <div id="accordion">
        <div class="card mt-2">
          <button
            id="deviceInfomation"
            class="card-header btn btn-primary d-flex py-3 rounded"
            data-toggle="collapse"
            data-target="#deviceInformation"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <i class="material-icons" style="margin-right:7px">tablet</i>
            <span>Device</span>
          </button>
          <div
            id="deviceInformation"
            class="collapse"
            aria-labelledby="deviceInfomation"
            data-parent="#deviceInformation"
          >
            <div class="card-body">
              <div class>
                <ul v-if="deviceInfo.hasInfo" class="list-group list-group-flush">
                  <li class="list-group-item">
                    <span class="font-weight-bold">ID:</span>
                    <span class="float-right text-capitalize">{{deviceInfo.device_id}}</span>
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">Product:</span>
                    <span class="float-right">corpuls simulation</span>
                  </li>
                </ul>
                <ul v-if="!deviceInfo.hasInfo" class="list-group list-group-flush">
                  <li class="list-group-item">No device info</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- mobile -->
</template>
<script>
import storage from "store";
export default {
  name: "DeviceInformation",
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    }
  }
};
</script>

<style scoped>
@media (max-width: 991px) {
  .btn-group {
    width: 100%;
  }
}

.btn.btn-primary.dropdown-toggle-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
</style>
